import styled from "styled-components";

const ProductCategoryTypePanelStyled = styled.div`

`;

export default ProductCategoryTypePanelStyled;